// extracted by mini-css-extract-plugin
export default {"suffix":"T29D6T1GotAMqVPAfwGE","iconOn":"ODqepGy6js7u13Ba1jIO","iconOff":"u6hMlwGDJQ5Gr7aFIxNN"};